<template>
    <van-action-sheet v-model="show" title="传承师选择">
        <div class="search-wrap flex rcb">
            <input v-model="searchKey" class="search-input-item" id="search-key" placeholder="搜索传承师姓名" />
            <van-button class="btn" type="info" size="small" @click="_onRefresh">搜索</van-button>
        </div>
        <div class="list-page">
            <div class="scrollerView">
                <scroller :on-refresh="_onRefresh" :on-infinite="infinite" :showTips="showListTips" ref="infinite" class="scroller">
                    <div class="ul">
                        <div class="li" v-for="(item, index) in dataSources" :key="index" @click="select" :data-index="index">
                            <div class="radio td-fsc">
                                <div class="radio"></div>
                            </div>
                            <div class="label">
                                <div class="avatar">
                                    <img :src="item.inheritor_cover" />
                                </div>
                                <div class="info">
                                    <div class="h1">{{ item.inheritor_name }}</div>
                                    <div class="p">{{ item.inheritor_introduce }}</div>
                                </div>
                            </div>
                        </div>
                        <van-empty description="暂无信息～" v-if="dataSources.length < 1" />
                    </div>
                </scroller>
            </div>
        </div>
    </van-action-sheet>
</template>
<script>
export default {
    name: "picker-master",
    data() {
        return {
            show: false,
            showListTips: true,

            searchKey: '',
            page: 0,
            limit: 20,
            dataSources: [],
        };
    },
    computed: {
        showAddress() {
            return this.show;
        },
    },
    mounted() {
        // 实例创建完成
        this._onRequestDataSources();
    },
    methods: {
        open() {
            this.show = true;
        },
        // 刷新
        _onRefresh() {
            this.page = 1;
            this._onRequestDataSources();
            setTimeout(
                function() {
                    this.$refs.infinite && this.$refs.infinite.finishPullToRefresh();
                }.bind(this),
                1000
            );
        },
        // 继续请求
        infinite() {
            this.page++;
            this._onRequestDataSources();
        },
        // 请求地址数据
        async _onRequestDataSources() {
            let url = this.API.master_list;
            let params = {
                token: this.Lockr.get("token"),
                page: this.page,
                limit: this.limit,
                keyword: this.searchKey,
            };
            let result = await this.$post(url, params);
            let dataSourcesTemp = this.dataSources.slice();
            let dataList = result.data.data;
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                if (this.page === 1) {
                    dataSourcesTemp = dataList;
                    this._dataSource = result.data.data;
                    if (!result.data.data || result.data.data.length < 1) {
                        this.showListTips = false;
                    }
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList);
                    }
                }
                this.dataSources = dataSourcesTemp;
                this.$refs.infinite && this.$refs.infinite.finishInfinite(dataList.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 选择地址
        select(e) {
            let { index } = e.currentTarget.dataset;
            let item = this.dataSources[index];
            this.$emit('confirm', item)
            this.show = false
        },
    },
};
</script>
<style lang="less" scoped>

.search-wrap {
    padding: 0 15px 15px;
    .search-input-item {
        flex: 1;
        height: 32px;
        text-indent: 15px;
        margin-right: 15px;
        border-radius: 50px;
        background: #f7f8f9;
    }
}

.list-page {
    position: relative;
    border-top: solid #eee 1px;

    .scrollerView {
        height: 80vh;
    }
}

.ul {
    .li {
        background: #fff;
        padding: 10px;
        border-bottom: solid #eee 1px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .radio {
            img {
                width: 15px;
                height: 15px;
                object-fit: contain;
                margin-right: 10px;
            }

            .radio {
                width: 15px;
                height: 15px;
                border: 1px solid #979797;
                border-radius: 50%;
                margin-right: 10px;
                box-sizing: border-box;
            }
        }

        .label {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .avatar {
                width: 46px;
                height: 46px;
                flex-shrink: 0;
                overflow: hidden;
                margin-right: 10px;
                border-radius: 4px;
                background: #f7f8f9;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .info {
                .h1 {
                    color: #333;
                    font-size: 15px;
                    font-weight: 600;
                }

                .p {
                    color: #666;
                    font-size: 12px;
                    margin-top: 5px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }
}
</style>